import { BooleanInput } from '@angular/cdk/coercion';
import { NgClass } from '@angular/common';
import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    forwardRef,
    Input,
    OnDestroy,
    OnInit,
} from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { HippoNavigationService } from '@hippo/components/navigation/navigation.service';
import { HippoNavigationItem } from '@hippo/components/navigation/navigation.types';
import { HippoVerticalNavigationBasicItemComponent } from '@hippo/components/navigation/vertical/components/basic/basic.component';
import { HippoVerticalNavigationCollapsableItemComponent } from '@hippo/components/navigation/vertical/components/collapsable/collapsable.component';
import { HippoVerticalNavigationDividerItemComponent } from '@hippo/components/navigation/vertical/components/divider/divider.component';
import { HippoVerticalNavigationSpacerItemComponent } from '@hippo/components/navigation/vertical/components/spacer/spacer.component';
import { HippoVerticalNavigationComponent } from '@hippo/components/navigation/vertical/vertical.component';
import { Subject, takeUntil } from 'rxjs';
import { PermissionDirective } from 'app/core/directives/permission.directive';
import { NavigationService } from 'app/core/navigation/navigation.service';
import { MyDataService } from 'app/modules/admin/team/my-data/my-data.service';
import { provideTranslocoScope } from '@jsverse/transloco';

@Component({
    selector: 'hippo-vertical-navigation-group-item',
    templateUrl: './group.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        NgClass,
        MatIconModule,
        HippoVerticalNavigationBasicItemComponent,
        HippoVerticalNavigationCollapsableItemComponent,
        HippoVerticalNavigationDividerItemComponent,
        forwardRef(() => HippoVerticalNavigationGroupItemComponent),
        HippoVerticalNavigationSpacerItemComponent,
        PermissionDirective,
    ],
})
export class HippoVerticalNavigationGroupItemComponent
    implements OnInit, OnDestroy
{
    /* eslint-disable @typescript-eslint/naming-convention */
    static ngAcceptInputType_autoCollapse: BooleanInput;
    /* eslint-enable @typescript-eslint/naming-convention */

    @Input() autoCollapse: boolean;
    @Input() item: HippoNavigationItem;
    @Input() name: string;

    private _hippoVerticalNavigationComponent: HippoVerticalNavigationComponent;
    private _unsubscribeAll: Subject<any> = new Subject<any>();

    /**
     * Constructor
     */
    constructor(
        private _changeDetectorRef: ChangeDetectorRef,
        private _hippoNavigationService: HippoNavigationService,
        private _navigationService: NavigationService,
        private myDataService: MyDataService
    ) {}

    ngOnInit(): void {
        // Get the parent navigation component
        this._hippoVerticalNavigationComponent =
            this._hippoNavigationService.getComponent(this.name);

        // Subscribe to onRefreshed on the navigation component
        this._hippoVerticalNavigationComponent.onRefreshed
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe(() => {
                // Mark for check
                this._changeDetectorRef.markForCheck();
            });
    }

    toggleShow() {
        this.item.show = !this.item.show;
        if (this.item.number !== undefined) {
            this._navigationService.setMenuOpened(
                this.item.number,
                this.item.show
            );
        }
    }

    /**
     * On destroy
     */
    ngOnDestroy(): void {
        // Unsubscribe from all subscriptions
        this._unsubscribeAll.next(null);
        this._unsubscribeAll.complete();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Track by function for ngFor loops
     *
     * @param index
     * @param item
     */
    trackByFn(index: number, item: any): any {
        return item.id || index;
    }
}
